function getConstructorFieldsValue(config, group, constructorGridName) {
  const { constructorFieldsMap } = config;
  if (!constructorGridName) {
    return null;
  }
  if (!(constructorFieldsMap == null ? void 0 : constructorFieldsMap.has(constructorGridName))) {
    return null;
  }
  const constructorGridFields = constructorFieldsMap.get(constructorGridName);
  if (!constructorGridFields || !(constructorGridFields == null ? void 0 : constructorGridFields.has(group))) {
    return null;
  }
  return constructorGridFields.get(group);
}
export {
  getConstructorFieldsValue
};
